import React from 'react'

const PaginationItem = ({ page, pageNumber, link, ...props }) => {
  return (page === pageNumber || (page === 1 && !pageNumber))
    ? (
      <li className='f5 f6-m bg-black white tc lh-pagination br b--phantom-grey w8 w7-m'>
        {page}
      </li>
      )
    : (
      <li className='f5 f6-m bg-transparent tc lh-pagination br b--phantom-grey w8 w7-m'>
        <a
          className='no-underline hover-bg-gains-boro black w-100 h-100 db outline-0'
          data-event-action={`Page ${page}`}
          data-event-category='Search'
          href={link}
          {...props}
        >
          {page}
        </a>
      </li>
      )
}

export default PaginationItem
